export const DATE_FORMAT = 'dd/MM/yyyy';
export const DEFAULT_TIME = 'T00:00:00';
